import script from "./FileInfoListSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileInfoListSelect.vue?vue&type=script&setup=true&lang=ts"

import "./FileInfoListSelect.vue?vue&type=style&index=0&id=3cbf4b97&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbf4b97"]])

export default __exports__